import { THEME_NAMES } from "./config";
import { assetPackIds } from "nemuru-components";

export const telefonicaTheme = {
  zendeskCustomerSupport: false,
  themeName: THEME_NAMES.telefonica,
  logoUrl: "https://cdn.nemuru.com/assets/logos/telefonica-logo.svg",
  palette: {
    primary: {
      main: "#06f",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#031A34",
      contrastText: "#ffffff",
    },
    dark: {
      main: "#f2f4ff",
      contrastText: "#031A34",
      accent: "#06f",
      imageBackgroundOpacity: 0.85,
    },
    text: {
      title: "#031A34",
      primary: "#031A34",
      secondary: "#414B61",
    },
    status: {
      active: "#4ac687",
      approved: "#349a65",
      analysing: "#06f",
      sent: "#031A34",
      cancelled: "#d8d8d8",
      denied: "#e81e26",
    },
    info: {
      main: "#06f",
      contrastText: "#ffffff",
      light: "#f2f4ff",
    },
    warning: {
      main: "#f8cd51",
      contrastText: "#ffffff",
      light: "#fff6e7",
    },
    success: {
      main: "#479d38",
      contrastText: "#ffffff",
      light: "rgba(76, 205, 138,0.6)",
    },
    grey: {
      50: "#ffffff",
      100: "#ffffff",
      200: "#eae9e6",
      300: "#dad9d6",
      400: "#b6b5b2",
      500: "#969593",
      600: "#6e6d6b",
      700: "#5a5a57",
      800: "#3c3b39",
      900: "#1b1b19",
    },
  },
  assetPackDefsId: assetPackIds.OUTLINED,
  background: "#f4f4f4",
  customBorderRadius: {
    button: 0,
    paper: 0,
  },
  shadows: [
    "none",
    "none",
    "none", // 2 buttons
    "none", // 3 papers soft
  ],
  typography: {
    fontFamily: "Helvetica, Arial, sans-serif",
  },
};
